import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TitleComponent } from './title.component';
import { SafeHtmlPipeModule } from '@finder/shared/utils/pipes/safe-html/safe.html.module';
import { FontIconModule } from '@finder/shared/components/font-icon/font-icon.module';

@NgModule({
    imports: [
        CommonModule,
        SafeHtmlPipeModule,
        FontIconModule
    ],
    declarations: [
        TitleComponent,
    ],
    providers: [],
    exports: [
        TitleComponent,
    ]
})
export class TitleModule {}
